import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import _ from 'lodash';
import { DocumentPopupComponent } from './document-popup/document-popup.component';
import { DocumentacionService } from '../../services/documentacion.service';
import { DocEmpresa } from '../models/Documentacion/DocEmpresa';
import { DocEmpresaGrouped } from '../models/Documentacion/DocEmpresaGrouped';
import { CompanySideBarTreeViewService } from '../../services/company-side-bar-tree-view.service';
import { DocumentViewContainerComponent } from 'app/modules/employee-view/documentos/document-view-container/document-view-container.component';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    standalone: false
})
export class DocumentsComponent implements OnInit {

  @Input() companyId : any
  
  docEmpresaList: DocEmpresa[] = [];
  docEmpresaGroupList: DocEmpresaGrouped[] =[];
  isloading = false;
  selectedEmpresaId;

  constructor(
    private _dialog: MatDialog,
    private _documentacionService: DocumentacionService,
    private _sharedService: SharedService,
    private _pageLoaderService: PageLoaderService
    ) {       
    }

    ngOnInit(): void {
      this.selectedEmpresaId = this.companyId 
      this.GetAllDocEmpresaByEmpresaId(this.selectedEmpresaId);
    }
     

    public GetAllDocEmpresaByEmpresaId(empresaId: number) {
        this.isloading = true;
        this._documentacionService.GetAllDocEmpresaByEmpresaId(empresaId)
            .subscribe(res => {
                this.docEmpresaList = res.result;
                const resultGroupList = _.toArray(_.groupBy(res.result, 'tipo')) as any[];
                this.docEmpresaGroupList = [];
                if (resultGroupList) {
                    for (let i = 0; i < resultGroupList.length; i++) {
                        resultGroupList[i].sort(function (a, b) {
                            var dateA = new Date(a.fecha);
                            var dateB = new Date(b.fecha);
                            return dateA > dateB ? 1 : -1;
                        });
                        var docEmpresa = new DocEmpresaGrouped();
                        if (resultGroupList[i][0]) {
                            docEmpresa.tipo = resultGroupList[i][0].tipo;
                        }
                        if (resultGroupList[i]) {
                            docEmpresa.docEmpresaList = resultGroupList[i];
                        }
                        this.docEmpresaGroupList.push(docEmpresa);
                    }
                }
                this.isloading = false;
            }, err => {
                console.error(err);
                this._sharedService.ShowSnackBar('Proceso fallido');
                this.isloading = false;
            });
    }


    public addEmpresaDocumentation() {
        const modalRef = this._dialog.open(DocumentPopupComponent, { data: this.selectedEmpresaId });
        modalRef.afterClosed().subscribe(res => {
            this.GetAllDocEmpresaByEmpresaId(this.selectedEmpresaId);
        });
    }

    public deleteDocument(model: DocEmpresa) {
        const dialogData = new ConfirmDialogModel('¿Eliminar documento?', "");
        const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });
    
        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                this.isloading = true; 
                this._documentacionService.DeleteEmpresaDocument(model.documentoId)
                    .subscribe(res => {
                        this.isloading = false; 
                        if (res.code === 0) {
                            this.GetAllDocEmpresaByEmpresaId(this.selectedEmpresaId);
                            this._sharedService.ShowSnackBar('Borrado exitosamente');
                        } else {
                            this._sharedService.ShowSnackBar('Eliminar falla');
                        }
                    }, err => {
                        this.isloading = false; 
                        this._sharedService.ShowSnackBar('Eliminar falla');
                        console.error(err);
                    });
            }
        });
    }

    public downloadDocument(model: DocEmpresa) {
        this._pageLoaderService.ShowPageLoader();
        this._documentacionService.GetDocEmpresaDocumentByDocumentId(model.documentoId).subscribe(res => {
            if (res.code === 0 && res.result) {
                var a = document.createElement('a');
                a.setAttribute("href", 'data:application/octet-stream;base64,' + res.result.documento);
                var fileName = `TBX${model.documentoId}.${model.tipoDocumento.toLowerCase()}`;
                a.setAttribute("download", fileName);
                a.click();
            } else {
                this._sharedService.ShowSnackBar('Proceso fallido');
            }
            this._pageLoaderService.HidePageLoader();
        }, error => {
            this._sharedService.ShowSnackBar('Proceso fallido');
            console.error(error);
            this._pageLoaderService.HidePageLoader();
        });

    }

    public ViewDocument(doc) {        
        const dialogRef = this._dialog.open(DocumentViewContainerComponent, {
            data: { EmployeeDocId: doc.documentoId, Type: '4' },width: '70vw',
        });
        dialogRef.afterClosed().subscribe((_) => {});
        document.querySelectorAll('.hiddenCanvasElement').forEach(e => e.remove())
    }

}
